import React from 'react'
import { Card } from '@arnsbogroup/react-voicearchive'
import {
  FormattedMessage,
  useIntl,
} from 'react-intl'
import messages from './messages'

const ChildVoiceCard = () => {
  const { formatMessage } = useIntl()

  return (
    <Card className="bg-white">
        <img className="w-full h-56 object-cover object-top" src='https://www.voicearchive.com/wp-content/uploads/2022/10/girl-star-singer-artist-in-a-black-blouse-with-hea-2022-05-12-00-10-58-utc-1.jpg' alt={formatMessage(messages.caption)} />
        <p className="p-2 text-sm">
          <FormattedMessage {...messages.caption} 
          values={{
              b: chunks => <b className='font-medium'>{chunks}</b>,
            }} 
          />
        </p>
    </Card>
  )
}

export default ChildVoiceCard
